import { getWithAuthentication, postWithAuthentication } from './api'
import { BASE_URL, FEEDBACK_ENDPOINT } from '@/assets/constants/api_endpoints'

/**
 * Submit or update a feedback vote for an AI-generated output.
 * The backend upserts — re-voting with the same value is safe.
 *
 * @param {string} featureType - One of the FEEDBACK_FEATURE_TYPE_* constants
 * @param {number} targetId    - PK of the rated record
 * @param {boolean} value      - true = thumbs up, false = thumbs down
 * @returns {Promise<Object>}  Feedback record { id, feature_type, value, created_at, updated_at }
 */
export async function submitFeedback(featureType, targetId, value) {
  const response = await postWithAuthentication(BASE_URL, FEEDBACK_ENDPOINT, {
    feature_type: featureType,
    target_id: targetId,
    value,
  })
  return response
}

/**
 * Retrieve the current vote for a given item, or null if not yet voted.
 *
 * @param {string} featureType - One of the FEEDBACK_FEATURE_TYPE_* constants
 * @param {number} targetId    - PK of the rated record
 * @returns {Promise<Object|null>} Feedback record or null
 */
export async function getFeedback(featureType, targetId) {
  const endpoint = `${FEEDBACK_ENDPOINT}?feature_type=${encodeURIComponent(featureType)}&target_id=${encodeURIComponent(targetId)}`
  const response = await getWithAuthentication(BASE_URL, endpoint)
  return response.data
}
